import { API } from 'configs';
import { useRequest } from 'utils/AxiosHooks';

const useGetRank = () => useRequest({ url: API.RANK.LIST, fetchOnMount: true });

export { useGetRank };
